if (!customElements.get('second-chance')) {
    class SecondChance extends HTMLElement {

        constructor() {
            super();

            if (this.hidden) {
                this.initLazySection();
            } else {
                window.initLazyScript(this, this.initLazySection.bind(this));
            }
        }

        initLazySection() {
            const me = this;

            me.contentEL = me.querySelector('.second-chance__content');
            me.spinnerEL = me.querySelector('.loading-spinner');

            // Bind to on:variant:change event for this product
            me.variantPicker = me.closest('.product-info').querySelector('variant-picker');
            me.handle = me.dataset.handle;

            if (me.variantPicker && !me.bound) {
                me.bound = true;
                me.variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
            }
        }

        /**
         * Handles a 'change' event on the variant picker element
         * @param {object} evt - Event object
         */
        handleVariantChange(evt) {
            const me = this;

            if (evt.detail.variant) {

                me.contentEL.style.opacity = '0';
                me.spinnerEL.removeAttribute('hidden');
                me.spinnerEL.setAttribute('aria-hidden', 'false');

                const variantId = evt.detail.variant.id;

                const sectionId = me.closest('.product').dataset.section;

                fetch('/products/' + me.handle + '?variant=' + variantId + '&section_id=' + sectionId)
                    .then(response => response.text())
                    .then(htmlString => {
                        const parser = new DOMParser();
                        const resultDocument = parser.parseFromString(htmlString, 'text/html');
                        const newSecondChanceContent = resultDocument.querySelector('.second-chance__content');

                        if (newSecondChanceContent) {

                            me.contentEL.replaceWith(newSecondChanceContent);
                            me.contentEL = me.querySelector('.second-chance__content');

                            me.spinnerEL.setAttribute('hidden', '');
                            me.spinnerEL.setAttribute('aria-hidden', 'true');

                            me.contentEL.style.opacity = '1';
                        }
                    })
                    .catch(error => {
                        //console.error('Fetch error:', error);
                    });
            }
        }
    }

    customElements.define('second-chance', SecondChance);
}